export default class Gallery
{
    constructor(rootNode, props) {
    }
}

